import config from '@/config'
import urlParameters from './urlParameters'

function isDefault () {
  return urlParameters.getBrand() === config.app.brands.default
}

function isWhite () {
  return urlParameters.getBrand() === config.app.brands.white
}

function isWhite1 () {
  return urlParameters.getBrand() === config.app.brands.white1 || urlParameters.getBrand() === config.app.brands.ultrawide
}

function isTranslux () {
  return urlParameters.getBrand() === config.app.brands.translux
}

function isTranslux1 () {
  return urlParameters.getBrand() === config.app.brands.translux1
}

function isTranslux2 () {
  return urlParameters.getBrand() === config.app.brands.translux2
}

function isTranslux3 () {
  return urlParameters.getBrand() === config.app.brands.translux3
}

function isTranslux4 () {
  return urlParameters.getBrand() === config.app.brands.translux4
}

function isDarkviolet () {
  return urlParameters.getBrand() === config.app.brands.darkviolet
}

function isPinegreen () {
  return urlParameters.getBrand() === config.app.brands.pinegreen
}

function isTranslux5 () {
  return urlParameters.getBrand() === config.app.brands.translux5
}

function isUltraWide () {
  return urlParameters.getBrand() === config.app.brands.ultrawide
}

export default {
  isDefault,
  isWhite,
  isWhite1,
  isDarkviolet,
  isPinegreen,
  isTranslux,
  isTranslux1,
  isTranslux2,
  isTranslux3,
  isTranslux4,
  isTranslux5,
  isUltraWide
}



// WEBPACK FOOTER //
// ./src/library/cdu/brands.js